import { SALESFORCE_FIELD_MAX_LENGTH, exceedsFieldLength } from '../../constants';

import { parseIsoDateUtc } from './computeNightlySurcharge';
import type { SurchargePeriodFormValues } from './types';

export const SURCHARGE_NAME_TOO_LONG = `Period name must be ${SALESFORCE_FIELD_MAX_LENGTH.surchargeName} characters or fewer.`;

/** `specificDays` is form-only: a period saved with no weekdays already means every day. */
export function validateSurchargePeriod(values: SurchargePeriodFormValues, specificDays = false): Array<string> {
  const errors: Array<string> = [];

  if (values.name.trim().length < 1) {
    errors.push('Period name is required.');
  }

  if (exceedsFieldLength(values.name, SALESFORCE_FIELD_MAX_LENGTH.surchargeName)) {
    errors.push(SURCHARGE_NAME_TOO_LONG);
  }

  const start = parseIsoDateUtc(values.startDate);
  const end = parseIsoDateUtc(values.endDate);

  if (start == null) {
    errors.push('From must be a real ISO YYYY-MM-DD date.');
  }

  if (end == null) {
    errors.push('To must be a real ISO YYYY-MM-DD date.');
  }

  if (start != null && end != null && values.startDate > values.endDate) {
    errors.push('From must be on or before To.');
  }

  if (!Number.isFinite(values.sellAud) || values.sellAud <= 0) {
    errors.push('Sell AUD must be greater than 0.');
  }

  if (values.cost != null && (!Number.isFinite(values.cost) || values.cost < 0)) {
    errors.push('Cost must be 0 or more.');
  }

  if (specificDays && values.weekdays.length === 0) {
    errors.push('Pick at least one day of the week.');
  }

  if (values.rooms !== 'all' && values.rooms.length === 0) {
    errors.push('Pick at least one room.');
  }

  if (values.options.length === 0) {
    errors.push('Pick at least one package option.');
  }

  return errors;
}
